import { checkEmail, checkNotEmpty } from '../../helpers/validators';
const validateEmail = ({ value, required }) => {
    if (required) {
        return checkNotEmpty({ value }) || checkEmail({ value: value || '' });
    }
    return value ? checkEmail({ value }) : null;
};
export const validateEmailWithMatch = ({ emailMatchValidationInfo, ...rest }) => validateEmail(rest) || emailMatchValidationInfo;
